import type { IconNode } from '../types';

/**
 * @name mouth
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMmE1MC41IDUwLjUgMCAwMDIwIDAgMSAxIDAgMDAtMS0xIiAvPgogIDxwYXRoIGQ9Ik0yLjQ1NyAxMS4xNTlhMSAxIDAgMDAtLjMwNyAxLjM2OSAxMS41OSAxMS41OSAwIDAwMTkuNyAwIDEgMSAwIDAwLS4zMDgtMS4zNjhjLTIuNDI2LTEuNTY4LTMuNjUtMi4yODQtNS40NzktMy42NDRhMi42IDIuNiAwIDAwLTMuMzczLjIwOCAxIDEgMCAwMS0xLjM4IDAgMi42MiAyLjYyIDAgMDAtMy4zNzMtLjIwOGMtMS44MyAxLjM2LTMuMDUzIDIuMDc2LTUuNDggMy42NDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mouth
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Mouth: IconNode = [
  ['path', { d: 'M2 12a50.5 50.5 0 0020 0 1 1 0 00-1-1' }],
  [
    'path',
    {
      d: 'M2.457 11.159a1 1 0 00-.307 1.369 11.59 11.59 0 0019.7 0 1 1 0 00-.308-1.368c-2.426-1.568-3.65-2.284-5.479-3.644a2.6 2.6 0 00-3.373.208 1 1 0 01-1.38 0 2.62 2.62 0 00-3.373-.208c-1.83 1.36-3.053 2.076-5.48 3.643',
    },
  ],
];

export default Mouth;
